import { Dispatch } from "react"
import { CoreStopPeriod } from "../models/CoreModels"
import InstanceClient from "../services/InstanceClient"
import StatusCode from "../util/StatusCode"
import { Action, Reducer } from "redux"
import { EmptyRequestState, RequestState } from "../models/RequestState"


enum ModuleStopPeriodType {
    GET_STOP_PERIODS = 'GET_STOP_PERIODS',
    CREATE_STOP_PERIOD = 'CREATE_STOP_PERIOD',
    UPDATE_STOP_PERIOD = 'UPDATE_STOP_PERIOD',
    DELETE_STOP_PERIOD = 'DELETE_STOP_PERIOD'
}

export interface ModuleStopPeriodState {
    moduleStopPeriods: RequestState<CoreStopPeriod[]>
    createModuleStopPeriod: EmptyRequestState
    updateModuleStopPeriod: EmptyRequestState
    deleteModuleStopPeriod: EmptyRequestState
}
interface ModuleStopPeriod_Get extends Action<ModuleStopPeriodType> {
    type: ModuleStopPeriodType.GET_STOP_PERIODS,
    moduleStopPeriods: RequestState<CoreStopPeriod[]>
}

interface ModuleStopPeriod_Create extends Action<ModuleStopPeriodType> {
    type: ModuleStopPeriodType.CREATE_STOP_PERIOD
    createModuleStopPeriod: EmptyRequestState
}

interface ModuleStopPeriod_Update extends Action<ModuleStopPeriodType> {
    type: ModuleStopPeriodType.UPDATE_STOP_PERIOD
    updateModuleStopPeriod: EmptyRequestState
}

interface ModuleStopPeriod_Delete extends Action<ModuleStopPeriodType> {
    type: ModuleStopPeriodType.DELETE_STOP_PERIOD
    deleteModuleStopPeriod: EmptyRequestState
}

type ModuleStopPeriodAction =
    ModuleStopPeriod_Get |
    ModuleStopPeriod_Create |
    ModuleStopPeriod_Update |
    ModuleStopPeriod_Delete;


export const GetModuleStopPeriods = (moduleId: string) => (dispatch: Dispatch<ModuleStopPeriod_Get>) => {
    dispatch({
        type: ModuleStopPeriodType.GET_STOP_PERIODS,
        moduleStopPeriods: { code: StatusCode.PENDING }
    });
    return InstanceClient.get<CoreStopPeriod[]>(`/api/core/module/${moduleId}/moduleStopPeriods`)
        .then(res => {
            dispatch({
                type: ModuleStopPeriodType.GET_STOP_PERIODS,
                moduleStopPeriods: { code: StatusCode.COMPLETE, data: res.data }
            });
        })
        .catch(err => {
            dispatch({
                type: ModuleStopPeriodType.GET_STOP_PERIODS,
                moduleStopPeriods: { code: StatusCode.ERROR, error: err }
            });
        });
};

export const CreateModuleStopPeriod = (moduleId: string, stopPeriod: Partial<CoreStopPeriod>) => (dispatch: Dispatch<ModuleStopPeriod_Create>) => {
    dispatch({
        type: ModuleStopPeriodType.CREATE_STOP_PERIOD,
        createModuleStopPeriod: { code: StatusCode.PENDING }
    })
    return InstanceClient.post(`/api/core/module/${moduleId}/createStopPeriod`, stopPeriod)
        .then(res => {
            dispatch({
                type: ModuleStopPeriodType.CREATE_STOP_PERIOD,
                createModuleStopPeriod: { code: StatusCode.COMPLETE }
            });
            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ModuleStopPeriodType.CREATE_STOP_PERIOD,
                createModuleStopPeriod: { code: StatusCode.ERROR, error }
            });
            return StatusCode.ERROR;
        });
};

export const UpdateModuleStopPeriod = (moduleId: string, stopPeriod: Partial<CoreStopPeriod>) => (dispatch: Dispatch<ModuleStopPeriod_Update>) => {
    dispatch({
        type: ModuleStopPeriodType.UPDATE_STOP_PERIOD,
        updateModuleStopPeriod: { code: StatusCode.PENDING }
    })
    return InstanceClient.put(`/api/core/module/${moduleId}/editStopPeriod`, stopPeriod)
        .then(res => {
            dispatch({
                type: ModuleStopPeriodType.UPDATE_STOP_PERIOD,
                updateModuleStopPeriod: { code: StatusCode.COMPLETE }
            });
            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ModuleStopPeriodType.UPDATE_STOP_PERIOD,
                updateModuleStopPeriod: { code: StatusCode.ERROR, error }
            });
            return StatusCode.ERROR;
        });
};

export const DeleteModuleStopPeriod = (moduleId: string, id: string) => (dispatch: Dispatch<ModuleStopPeriod_Delete>) => {
    dispatch({
        type: ModuleStopPeriodType.DELETE_STOP_PERIOD,
        deleteModuleStopPeriod: { code: StatusCode.PENDING }
    })
    return InstanceClient.delete(`/api/core/module/${moduleId}/deleteStopPeriod/${id}`)
        .then(res => {
            dispatch({
                type: ModuleStopPeriodType.DELETE_STOP_PERIOD,
                deleteModuleStopPeriod: { code: StatusCode.COMPLETE }
            });
            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ModuleStopPeriodType.DELETE_STOP_PERIOD,
                deleteModuleStopPeriod: { code: StatusCode.ERROR, error }
            });
            return StatusCode.ERROR;
        });
};


const initialState: ModuleStopPeriodState = {
    moduleStopPeriods: { code: StatusCode.NONE },
    createModuleStopPeriod: { code: StatusCode.NONE },
    updateModuleStopPeriod: { code: StatusCode.NONE },
    deleteModuleStopPeriod: { code: StatusCode.NONE },
}

export const reducer: Reducer<ModuleStopPeriodState, ModuleStopPeriodAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ModuleStopPeriodType.GET_STOP_PERIODS:
            return {
                ...state,
                moduleStopPeriods: action.moduleStopPeriods
            };
        case ModuleStopPeriodType.CREATE_STOP_PERIOD:
            return {
                ...state,
                createModuleStopPeriod: action.createModuleStopPeriod
            };
        case ModuleStopPeriodType.UPDATE_STOP_PERIOD:
            return {
                ...state,
                updateModuleStopPeriod: action.updateModuleStopPeriod
            };
        case ModuleStopPeriodType.DELETE_STOP_PERIOD:
            return {
                ...state,
                deleteModuleStopPeriod: action.deleteModuleStopPeriod
            };
        default:
            return state;
    }
} 